import React from "react";
import styled from "styled-components";
import {Table} from "antd";

const Wrapper = styled.div`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 16px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
`;

const StyledTable = styled(Table)`
    width: 100%;

    .ant-table-thead > tr > th {
        font-size: 14px;
        font-weight: 600;
    }

    .ant-table-tbody > tr > td {
        font-size: 13px;
    }
`;

export const TableWrapper = ({children, ...tableProps}) => {
    return (
        <Wrapper>
            <StyledTable size="small" style={{width: "100%"}} {...tableProps}>
                {children}
            </StyledTable>
        </Wrapper>
    );
};
